import type { SpinnerSize } from '@creditflowresearch/uilib/Loader/Spinner';
import styles from './button.module.scss';
import type { ButtonVariant, ButtonColor, ButtonSize } from './types';

export const variantClassMap: Record<ButtonVariant, string> = {
  solid: styles.solid,
  outline: styles.outline,
  text: styles.text,
};

export const colorClassMap: Record<ButtonColor, string> = {
  primary: styles.primary,
  success: styles.success,
  error: styles.error,
  gradient: styles.gradient,
  onDark: styles.onDark,
};

export const sizeClassMap: Record<ButtonSize, string> = {
  L: styles.sizeL,
  M: styles.sizeM,
  S: styles.sizeS,
};

export const defaultIconSize: Record<ButtonSize, number> = {
  L: 20,
  M: 16,
  S: 12,
};

export const spinnerSizeMap: Record<ButtonSize, SpinnerSize> = {
  S: 'XS',
  M: 'S',
  L: 'M',
};

export const fitClassMap: Record<string, string> = {
  fitInline: styles.fitInline,
  fitFull: styles.fitFull,
  fitSmInline: styles.fitSmInline,
  fitSmFull: styles.fitSmFull,
  fitMdInline: styles.fitMdInline,
  fitMdFull: styles.fitMdFull,
  fitXlInline: styles.fitXlInline,
  fitXlFull: styles.fitXlFull,
};
